<template>
  <page>
    <lazy-div :load="doInit">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newMode">mdi-plus</v-icon>
          <v-icon v-else-if="reviewMode">mdi-pencil</v-icon>
          <v-icon v-else-if="queryMode">mdi-magnify</v-icon>
          <v-toolbar-title v-if="newMode">Create New Tariff Benefit</v-toolbar-title>
          <v-toolbar-title v-else-if="reviewMode">Edit Tariff Benefit</v-toolbar-title>
          <v-toolbar-title v-else-if="queryMode">View Existing Tariff Benefit</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container grid-list-md>
            <v-layout row wrap v-if="newMode">
              <v-flex xs6>
                <v-autocomplete
                  :items="scheme"
                  v-model="tariffBenForm.scheme"
                  :label="tariffBenLabel.scheme"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('tariffBenForm.scheme')"
                  data-vv-name="tariffBenForm.scheme"
                  :data-vv-as="tariffBenLabel.scheme"
                  v-validate="'required'"
                  @change="getPlanNo($event)"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  :items="planno"
                  v-model="tariffBenForm.planNo"
                  :label="tariffBenLabel.planNo"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('tariffBenForm.planNo')"
                  data-vv-name="tariffBenForm.planNo"
                  :data-vv-as="tariffBenLabel.planNo"
                  v-validate="'required'"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  :items="tariff"
                  v-model="tariffBenForm.tariff"
                  :label="tariffBenLabel.tariff"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('tariffBenForm.tariff')"
                  data-vv-name="tariffBenForm.tariff"
                  :data-vv-as="tariffBenLabel.tariff"
                  v-validate="'required'"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  :items="buscls"
                  v-model="tariffBenForm.busCls"
                  :label="tariffBenLabel.busCls"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('tariffBenForm.busCls')"
                  data-vv-name="tariffBenForm.busCls"
                  :data-vv-as="tariffBenLabel.busCls"
                  v-validate="'required'"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  :items="benefit"
                  v-model="tariffBenForm.benefit"
                  :label="tariffBenLabel.benefit"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('tariffBenForm.benefit')"
                  data-vv-name="tariffBenForm.benefit"
                  :data-vv-as="tariffBenLabel.benefit"
                  v-validate="'required'"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <cal-picker
                  v-model="tariffBenForm.effDate"
                  :label="tariffBenLabel.effDate"
                  :data-vv-as="tariffBenLabel.effDate"
                  data-vv-name="tariffBenForm.effDate"
                  :error-messages="errors.collect('tariffBenForm.effDate')"
                  v-validate="'required'"
                ></cal-picker>
              </v-flex>
            </v-layout>

            <!-- Query -->
            <v-layout row wrap v-if="!newMode">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffBenLabel.scheme }}</v-subheader>
                <div class="queryValue" v-for="item in filterSchemeList" :key="item.label">{{ item.label }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffBenLabel.planNo }}</v-subheader>
                <div class="queryValue" v-for="item in filterPlanNoList" :key="item.label">{{ item.label }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffBenLabel.tariff }}</v-subheader>
                <div class="queryValue" v-for="item in filterTariffList" :key="item.label">{{ item.label }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffBenLabel.busCls }}</v-subheader>
                <div class="queryValue" v-for="item in filterBusClsList" :key="item.label">{{ item.label }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffBenLabel.benefit }}</v-subheader>
                <div class="queryValue" v-for="item in filterBenefitList" :key="item.label">{{ item.label }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffBenLabel.effDate }}</v-subheader>
                <div class="queryValue">{{ convertDate(tariffBenForm.effDate) }}</div>
              </v-flex>
            </v-layout>

            <v-layout row wrap v-if="!queryMode">
              <v-flex xs6>
                <cal-picker
                  v-model="tariffBenForm.expDate"
                  :label="tariffBenLabel.expDate"
                  :data-vv-as="tariffBenLabel.expDate"
                  data-vv-name="tariffBenForm.expDate"
                  :error-messages="errors.collect('tariffBenForm.expDate')"
                  v-validate="expDateValidation"
                ></cal-picker>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="tariffBenForm.basedOnUom"
                  :label="tariffBenLabel.basedOnUom"
                  :error-messages="errors.collect('tariffBenForm.basedOnUom')"
                  data-vv-name="tariffBenForm.basedOnUom"
                  :data-vv-as="tariffBenLabel.basedOnUom"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  :label="tariffBenLabel.napSubTotalLvl"
                  :items="napList"
                  v-model="tariffBenForm.napSubTotalLvl"
                  item-text="label"
                  item-value="value"
                  v-validate="'required'"
                  data-vv-name="tariffBenForm.napSubTotalLvl"
                  :data-vv-as="tariffBenLabel.napSubTotalLvl"
                  :error-messages="errors.collect('napSubTotalLvl')"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  :items="gapCalMethods"
                  v-model="tariffBenForm.gapCalMethod"
                  :label="tariffBenLabel.gapCalMethod"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('tariffBenForm.gapCalMethod')"
                  data-vv-name="tariffBenForm.gapCalMethod"
                  :data-vv-as="tariffBenLabel.gapCalMethod"
                  clearable
                ></v-autocomplete>
              </v-flex>
            </v-layout>

            <v-layout row wrap v-else>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffBenLabel.expDate }}</v-subheader>
                <div class="queryValue">{{ convertDate(tariffBenForm.expDate) }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffBenLabel.basedOnUom }}</v-subheader>
                <div class="queryValue">{{ tariffBenForm.basedOnUom }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffBenLabel.napSubTotalLvl }}</v-subheader>
                <div class="queryValue" v-for="item in filterSubNapLevelList" :key="item.label">{{ item.label }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffBenLabel.gapCalMethod }}</v-subheader>
                <div class="queryValue" v-for="item in filterGapCalMethodList" :key="item.label">{{ item.label }}</div>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffBenLabel.createdBy }}</v-subheader>
                <div class="queryValue">{{ tariffBenForm.createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ tariffBenLabel.createdDate }}</v-subheader>
                <div class="queryValue">{{ tariffBenForm.createdDate | formatDate }}</div>
              </v-flex>
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ tariffBenLabel.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ tariffBenForm.modifiedBy }}</div>
              </v-flex>
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ tariffBenLabel.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ tariffBenForm.modifiedDate | formatDate }}</div>
              </v-flex>
            </v-layout>
            <v-spacer class="mt-3"></v-spacer>
            <v-layout>
              <v-btn color="red darken-1" dark class=" mr-2" @click.native="doCancel">
                Cancel
                <v-icon right dark>mdi-cancel</v-icon>
              </v-btn>
              <v-btn v-if="!queryMode" color="primary" dark class=" mr-2" @click="doSave" :loading="submitting">
                Save
                <v-icon right>mdi-content-save</v-icon>
              </v-btn>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { formatDisplayDate, formatDisplayDateTime2, removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'
import { expandURI } from '@/utils/ajax'
import clone from 'clone'

export default {
  data() {
    return {
      submitting: false,
      newMode: false,
      reviewMode: false,
      queryMode: false,
      scheme: [],
      planno: [],
      tariff: [],
      buscls: [],
      benefit: [],
      tariffBenForm: {
        scheme: null,
        planNo: null,
        tariff: null,
        busCls: null,
        benefit: null,
        effDate: null,
        expDate: null,
        basedOnUom: '1',
        gapCalMethod: null,
        napSubTotalLvl: null,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      },
      tariffBenLabel: {
        scheme: 'Scheme',
        planNo: 'Plan No.',
        tariff: 'Tariff',
        busCls: 'Business Class',
        benefit: 'Benefit',
        effDate: 'Effective Date',
        expDate: 'Expiry Date',
        basedOnUom: 'Based On UOM',
        gapCalMethod: 'GAP Calculation Method',
        napSubTotalLvl: 'NAP Sub Total Level',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      gapCalMethods: [
        { label: 'C - Marine Cargo', value: 'C' },
        { label: 'E - Manually', value: 'E' },
        { label: 'I - Standard Individual(Insured)', value: 'I' },
        { label: 'L - NAP Subtotal Level', value: 'L' },
        { label: 'M - Motor Point (Multiplicative)', value: 'M' },
        { label: 'N - Motor NCD/NCB Rate', value: 'N' },
        { label: 'P - Motor Points (Additive)', value: 'P' },
        { label: 'S - Standard', value: 'S' }
      ],
      napList: [
        { label: 1, value: 1 },
        { label: 2, value: 2 },
        { label: 3, value: 3 },
        { label: 4, value: 4 },
        { label: 5, value: 5 },
        { label: 6, value: 6 },
        { label: 7, value: 7 },
        { label: 8, value: 8 },
        { label: 9, value: 9 }
      ]
    }
  },
  methods: {
    async doInit() {
      await this.$store.dispatch('tariffBenInit')
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.getCommonDataListDropDown('scheme')
      this.getCommonDataList2('planno', this.tariffBenForm.scheme)
      this.getCommonDataListDropDown('tariff')
      this.getCommonDataListDropDown('buscls')
      this.getCommonDataListDropDown('benefit')
      if (this.newTariffBen) {
        this.tariffBenForm.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
        this.tariffBenForm.createdDate = new Date()
        this.tariffBenForm.effDate = new Date()
        this.tariffBenForm.expDate = this.tariffBenForm.effDate
        this.tariffBenForm.gapCalMethod = 'S'
      } else {
        this.fetchData()
      }
    },
    async fetchData() {
      const apiURI = this.menu.tariffBen
      if (apiURI) {
        try {
          const expand = {
            scheme: this.tariffBenId.scheme,
            planNo: this.tariffBenId.planNo,
            tariff: this.tariffBenId.tariff,
            busCls: this.tariffBenId.busCls,
            benefit: this.tariffBenId.benefit,
            effDate: formatDisplayDateTime2(removeTime(this.tariffBenId.effDate))
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.tariffBenForm.scheme = data.pkgTarfBen.scheme
            this.tariffBenForm.planNo = data.pkgTarfBen.planNo
            this.tariffBenForm.tariff = data.pkgTarfBen.tariff
            this.tariffBenForm.busCls = data.pkgTarfBen.busCls
            this.tariffBenForm.benefit = data.pkgTarfBen.benefit
            this.tariffBenForm.effDate = data.pkgTarfBen.effDate
            this.tariffBenForm.expDate = data.pkgTarfBen.expDate
            this.tariffBenForm.basedOnUom = data.pkgTarfBen.baseOnUom
            this.tariffBenForm.gapCalMethod = data.pkgTarfBen.gapMethdod
            this.tariffBenForm.napSubTotalLvl = parseInt(data.pkgTarfBen.napLvl, 10)
            this.tariffBenForm.createdBy = data.createdBy
            this.tariffBenForm.createdDate = data.createdDate
            this.tariffBenForm.modifiedBy = data.modifiedBy
            this.tariffBenForm.modifiedDate = data.modifiedDate
            this.getCommonDataList2('planno', this.tariffBenForm.scheme)
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    getPlanNo(data) {
      this.planno = []
      this.getCommonDataList2('planno', this.tariffBenForm.scheme)
    },
    convertDate(date) {
      if (date !== null) {
        return formatDisplayDate(date)
      }
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newTariffBen) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doCreate() {
      const apiURI = this.menu.createTariffBen
      if (apiURI) {
        let messageFilters = clone(this.tariffBenForm)
        if (messageFilters.effDate !== null && messageFilters.effDate !== '') {
          messageFilters.effDate = formatDisplayDateTime2(removeTime(messageFilters.effDate))
        }

        if (messageFilters.expDate !== null && messageFilters.expDate !== '') {
          messageFilters.expDate = formatDisplayDateTime2(removeTime(messageFilters.expDate))
        }
        this.$http
          .post(apiURI, messageFilters)
          .then((result) => {
            const { data } = result
            if (data) {
              this.$router.push({ name: 'pckgTariffBen' })
              this.notify(data)
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updateTariffBen
      if (apiURI) {
        this.submitting = true
        let messageFilters = clone(this.tariffBenForm)

        if (messageFilters.effDate !== null && messageFilters.effDate !== '') {
          messageFilters.effDate = formatDisplayDateTime2(removeTime(messageFilters.effDate))
        }

        if (messageFilters.expDate !== null && messageFilters.expDate !== '') {
          messageFilters.expDate = formatDisplayDateTime2(removeTime(messageFilters.expDate))
        }

        try {
          const result = await this.$http.put(apiURI, messageFilters)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'pckgTariffBen' })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doCancel() {
      this.$router.push({ name: 'pckgTariffBen' })
    }
  },
  created() {
    const jsonData = JSON.parse(sessionStorage.getItem('tariffBen'))
    this.$store.commit('TARIFFBEN_COMMIT_KEY', jsonData)

    if (this.tariffBenId.tranMode !== '') {
      if (this.tariffBenId.tranMode === 'New') {
        this.newMode = true
      } else if (this.tariffBenId.tranMode === 'Review') {
        this.reviewMode = true
      } else if (this.tariffBenId.tranMode === 'Query') {
        this.queryMode = true
      }
    }

    this.$validator.extend('valExpiry', {
      getMessage(field, args) {
        return 'Expiry Date must be equal or greater than Effective Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var expDate = args[0]
        if (expDate) {
          return !isAfter(removeTime(expDate), removeTime(value))
        }
      }
    })
  },
  computed: {
    menu() {
      return this.$store.state.pkgParam.tariffBen.menu
    },
    newTariffBen() {
      return this.tariffBenId.tranMode === 'New'
    },
    tariffBenId() {
      return this.$store.state.pkgParam.tariffBen.tariffBenId
    },
    expDateValidation() {
      if (this.tariffBenForm.expDate !== '' && this.tariffBenForm.expDate !== null) {
        return 'entry|valExpiry:' + this.tariffBenForm.effDate
      } else {
        return ''
      }
    },
    filterSchemeList() {
      return this.scheme.filter((list) => {
        return list.value === this.tariffBenForm.scheme
      })
    },
    filterPlanNoList() {
      return this.planno.filter((list) => {
        return list.value === this.tariffBenForm.planNo
      })
    },
    filterTariffList() {
      return this.tariff.filter((list) => {
        return list.value === this.tariffBenForm.tariff
      })
    },
    filterBusClsList() {
      return this.buscls.filter((list) => {
        return list.value === this.tariffBenForm.busCls
      })
    },
    filterBenefitList() {
      return this.benefit.filter((list) => {
        return list.value === this.tariffBenForm.benefit
      })
    },
    filterGapCalMethodList() {
      return this.gapCalMethods.filter((list) => {
        return list.value === this.tariffBenForm.gapCalMethod
      })
    },
    filterSubNapLevelList() {
      return this.napList.filter((list) => {
        return list.value === this.tariffBenForm.napSubTotalLvl
      })
    }
  },
  filters: {
    formatDate(value) {
      return formatDisplayDate(value)
    }
  },
  mixins: [MessageMixin, commonAjaxMixin]
}
</script>
